// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"94ff8c52","453":"af5f961c"}[chunkId] + ".chunk.js";
};